$(".condition_link").click(function () {
  $("body").css({ overflow: "hidden" });
  $("body").css({ position: "static" }); // or use "initial" if you want to reset to the default value
  $(".product-popup .popup").fadeIn(500);
});


const EachSkck = document.querySelectorAll(".Skick1 .SwatchValue");
EachSkck.forEach((skck) => {
  skck.addEventListener('click', () => {
    // console.log("SwatchValue clicked");
    const activeDiv = document.querySelector('.Skick1 .SwatchValue.activeIT');
    activeDiv && activeDiv.classList.remove('activeIT');
    skck.classList.add('activeIT');
    const dataSkick = skck.getAttribute('data-value');
    const container = document.querySelectorAll('.popup-image-container');
    const oprionDesce = document.querySelectorAll('.oprion_desce');
    container.forEach((even) => {
      const getAttr = even.getAttribute('data-value');
      dataSkick == getAttr ? even.classList.add('active') : even.classList.contains('active') && even.classList.remove('active');
    });
    oprionDesce.forEach((mem) => {
      const attrGet = mem.getAttribute('data-value');
      dataSkick == attrGet ? mem.classList.add('active') : mem.classList.contains('active') && mem.classList.remove('active');
    });
  });
});

const checkboxes = document.querySelectorAll(".DataSkick .SizeSwatch__Radio");
const checkedCheckboxElement = [...checkboxes].find((checkbox) => checkbox.checked);
const valueOfchecked = checkedCheckboxElement?.getAttribute("value") || '';
const AllVal = document.querySelectorAll("span.SizeSwatch.SwatchValue");
AllVal.forEach((val) => {
  const attrValue = val.getAttribute("data-value");
  valueOfchecked == attrValue && val.click();
});

function slick1() {
  const everyCode = document.querySelector(".Skick1 .activeIT");
  const datattr = everyCode?.getAttribute("data-value") || '';
  const container = document.querySelectorAll('.popup-image-container');
  const oprionDesce = document.querySelectorAll('.oprion_desce');
  container.forEach((even) => {
    const getAttr = even.getAttribute('data-value');
    datattr == getAttr ? even.classList.add('active') : even.classList.contains('active') && even.classList.remove('active');
  });
  oprionDesce.forEach((mem) => {
    const attrGet = mem.getAttribute('data-value');
    datattr == attrGet ? mem.classList.add('active') : mem.classList.contains('active') && mem.classList.remove('active');
  });
}
slick1();

const allEv = document.querySelectorAll(".DataSkick .HorizontalList__Item .SizeSwatch");
allEv.forEach((evet) => {
  evet.addEventListener('click', (ev) => {
    const dataEve = evet.previousElementSibling.getAttribute('data-value');
    const container = document.querySelectorAll('.popup-image-container');
    const oprionDesce = document.querySelectorAll('.oprion_desce');
    container.forEach((even) => {
      const getAttr = even.getAttribute('data-value');
      dataEve == getAttr ? even.classList.add('active') : even.classList.contains('active') && even.classList.remove('active');
    });
    oprionDesce.forEach((mem) => {
      const attrGet = mem.getAttribute('data-value');
      dataEve == attrGet ? mem.classList.add('active') : mem.classList.contains('active') && mem.classList.remove('active');
    });
    const innerVal = evet.querySelector(".value").innerHTML;
    // console.log("Clicked element's innerHTML (only 'value' class):", innerVal);
    const eachEv = document.querySelectorAll('.Skick1');
    eachEv.forEach((each) => {
      const values = each.querySelector(".SwatchValue");
      // console.log("Current Value:", values.innerHTML);
      innerVal == values.innerHTML ? (values.classList.add("activeIT"), slick1()) : values.classList.contains("activeIT") && values.classList.remove("activeIT");
    });
  });
});

let slideIndex = 1;
function showSlides(n) {
  const sliderContainers = document.querySelectorAll('.popup-slider-container');
  sliderContainers.forEach((container) => {
    const slides = container.querySelectorAll('.popup-slide');
    n > slides.length ? slideIndex = 1 : n < 1 && (slideIndex = slides.length);
    slides.forEach((slide) => slide.style.display = 'none');
    slides[slideIndex - 1].style.display = 'flex';
  });
}
showSlides(slideIndex);
$('.popup-prev').click(() => showSlides(slideIndex -= 1));
$('.popup-next').click(() => showSlides(slideIndex += 1));
